var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagEn = function SvgFlagEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-en_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-en_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-en_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 24,
    x: -4,
    fill: "#1A47B8",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M-.49 0H-4v4l29.47 20H29v-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    d: "M-2.83 0 29 21.657V24h-1.143L-4 2.32V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.857 0H29v4S8.587 17.325-.857 24H-4v-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    d: "M29 0h-1.066L-4 21.675V24h1.17L29 2.338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.001 0h9.025v7.403H29v9.19H17.026V24H8.001v-7.408H-4v-9.19H8.001z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    fillRule: "evenodd",
    d: "M9.895 0h5.21v9.23H29v5.54H15.105V24h-5.21v-9.23H-4V9.23H9.895z",
    clipRule: "evenodd"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-en_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-en_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-4 0h33v24H-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-en_svg__c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 24,
    x: -4,
    fill: "#fff",
    rx: 3
  })))));
};
export default SvgFlagEn;